export function resolveCurrentUrl(start, end) {
    if (start.endsWith('/')) {
        start = start.substr(0, start.length - 1);
    }
    if (end.startsWith('/')) {
        return start + end;
    }
    return start + '/' + end;
}
export * from './Toast';
export * from './Transition';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/HOC/index.js
// module id = 480
// module chunks = 0